import { MorphemeRouteShell } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels.route-body";
import { Redirect, resolveRouteParam, Slot, useLocalSearchParams } from "@-/com.npmjs.expo-router";
import { BrowseNavBackButton } from "@-/dev.improve.haniverse.routes.nav.app.browse._context";

export default function BrowseMorphemeLayoutRoute() {
  const params = useLocalSearchParams<{
    morpheme: string | string[];
    tab?: string | string[];
    view?: string | string[];
  }>();
  // An empty dynamic segment means this screen was seeded without a param rather than navigated to
  // (see the anchor note in `browse/_layout.tsx`). There is no character to render, so send the user
  // to the browse index instead of a `Character not found: ""` dead end.
  if (resolveRouteParam(params.morpheme) === "") {
    return <Redirect href="/(nav)/(app)/browse/(browse-tabs)/levels" />;
  }

  return (
    <>
      <BrowseNavBackButton />
      <MorphemeRouteShell>
        <Slot />
      </MorphemeRouteShell>
    </>
  );
}
